import { render, staticRenderFns } from "./SendMailTemplateInputForm.vue?vue&type=template&id=65e7e5cd&scoped=true&"
import script from "./SendMailTemplateInputForm.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplateInputForm.vue?vue&type=script&lang=js&"
import style0 from "./SendMailTemplateInputForm.vue?vue&type=style&index=0&id=65e7e5cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7e5cd",
  null
  
)

export default component.exports